export default Object.freeze({

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " meses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SELECT_REPORT_TYPE: "Por favor seleccione al menos un canal para generar el informe.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscopio",
  BAR_GRAPH: "Gráfico de barras",
  DADOS: "Estado de la variable",
  DADOS_MENU: "Datos",
  INFORMATION: "Información",
  LIMIT: "Límite",
  STATUS_INFORMATION: "Información de Estado",
  STATUS_DADOS: "Estado",
  VALOR: "Valor",
  LOG: "Log",
  REPORT: "Informe",
  CONFIG: "Configuraciones",

  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",

  UPDATING_LANGUAGE_WAITING: "Cambiando idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  // ------------------------------ Datos ------------------------------

  DADOS_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o límite",
  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bueno",
  ATTENTION_STRING: "Atención",
  BAD_STRING: "Malo",
  FAULT_STRING: "Sin señal",
  UNKNOWN_STRING: "Desconocido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o señal",

  REMOVE_POSITIONING: "Excluir dispositivo con fallo",
  REMOVE_DEVICE_MODAL_CONTENT_1: "¿Está seguro de que desea excluir el dispositivo?",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en el próximo escaneo.",
  REMOVE_DEVICE_FAILURE: "Se produjo un error al eliminar el dispositivo: ",
  LIVE_LIST_DEVICE_FAULT_POPUP_TEXT_2: "Al hacer clic en la celda es posible excluir el dispositivo, si lo desea.",
  ADDRESS: "Dirección",
  AMPLITUDE: "Amplitud",
  UNBALANCE: "Desbalanceo",
  MIN_AMPLITUDE: "Amplitud mínima",
  MAX_AMPLITUDE: "Amplitud máxima",
  DEVIATION: "Desviación",
  NOISE: "Ruido",
  I_FAULTS: "Fallos",
  STATUS: "Señal",
  SIGNAL: "Señal",
  JITTER: "Jitter",
  FAULT_PERCENT: "% de fallo",
  COMMUNICATION: "Comunicación",
  FAULT: "Fallo",
  DATA_EXCHANGE_1: "Intercambio de",
  DATA_EXCHANGE_2: "datos",
  DATA_EXCHANGE: "Intercambio de datos",
  DATA_EXCHANGE_LINE1: "Troca\n",
  DATA_EXCHANGE_LINE2: "de\n",
  DATA_EXCHANGE_LINE3: "datos",

  PORCENTAGEM: "%",
  MILLIVOLT: "mV",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Indicactivo de problema en el canal A",
  CHANNEL_B_PROBLEM: "Indicactivo de problema en el canal B",
  MASTERS: "Maestro",
  SLAVES: "Esclavos",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  CURRENT_CHANNEL: "Canal actual",
  CHANNEL_TAG_STR: "Tag del canal",

  NETWORK_DATA: "Datos de la red",

  MODAL_TITLE: "Formas de onda características",

  TURNED_ON: "Encendida",
  TURNED_OFF: "Apagada",

  ANALYSIS_ERROR: "Se produjo un error al cambiar el estado del análisis",

  ANALYSIS: "Análisis",
  ANALYZER: "Analizador",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "El TS Scope PA encontró un error interno que impidió su funcionamiento correcto. Por favor, reinicie el TS Scope PA. Si el problema persiste, póngase en contacto con Toledo & Souza para obtener soporte.",
  INVERTED_POLARITY: "Existen dispositivos en la red con polaridad invertida.",
  MONGO_OFF: "El TS Scope PA detectó un error en su base de datos interna. Por favor, reinicie el TS Scope PA. Si el problema persiste, póngase en contacto con Toledo & Souza para obtener soporte.",
  PICO_NOT_FOUND: "El TS Scope PA encontró un error interno que impidió su funcionamiento correcto. Por favor, reinicie el TS Scope PA. Si el problema persiste, póngase en contacto con Toledo & Souza para obtener soporte.",
  MONGO_REPAIR_SUCCESS: "¡Error reparado correctamente! Por favor cierre el programa y ábralo nuevamente para que los cambios surtan efecto.",
  MONGO_REPAIR_ERROR: "No fue posible solucionar el problema. Por favor póngase en contacto para recibir soporte.",
  SCAN_FAIL_FOUND: "El TS Scope PA perdió la conexión con la red PROFIBUS PA; asegúrese de que esté conectado correctamente a la red. Después de realizar la conexión, por favor reinicie el TS Scope PA.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando analizador, por favor espere.",

  A_DEVICES: "Dispositivos A",
  B_DEVICES: "Dispositivos B",

  AMPLITUDE_POPUP_STR1: "Muestra la amplitud actual, mínima y máxima de la señal de cada uno de los dispositivos PA de la red.",
  AMPLITUDE_POPUP_STR2: "El valor mínimo es de 3 Vpp y el máximo de 8 Vpp.",
  SIGNAL_POPUP_STR: "Indicactivo de que la amplitud está fuera de la norma.",
  I_FAULTS_POPUP_STR: "Esclavo con problema en el intercambio de datos.",
  NOISE_POPUP_STR: "El Ruido</b> se calcula durante el tiempo de <b><i>idle</i></b> de cada uno de los dispositivos en la red y no debe superar <b>100 mV</b>. Estos valores son de orden práctico.",
  DEV_POPUP_STR1: "Indica el valor de desviación de la señal con respecto al oscilador de frecuencia, es decir, la relación de tiempo entre donde la señal debería cruzar el cero y donde efectivamente lo cruza.",
  DEV_POPUP_STR2: "Puede indicar acoplamiento capacitivo al bus o incluso un problema de hardware.",
  DEV_POPUP_STR3: "Los límites son de -0,8 μs a +1,6 μs.",

  DATA_EXCHANGE_POPUP_STR_1: "Indica que el esclavo está en intercambio de datos con el Maestro.",
  DATA_EXCHANGE_POPUP_STR_2: "Indica que el esclavo dejó de intercambiar datos con el Maestro.",

  FAULT_POPUP_STR_1: "No ocurrencia de problemas en los intercambios de datos.",
  FAULT_POPUP_STR_2: "Indica que en algún momento durante el análisis ocurrió un reintento.",
  FAULT_POPUP_STR_3: "Indica que en algún momento durante el análisis el esclavo dejó de intercambiar datos con el Maestro.",
  FAULT_POPUP_STR_4: "El TS Scope PA realiza la lectura de los datos en bloques, y no en streaming. Por ello, si ocurren reintentos fuera de la ventana de lectura, no serán detectados por el analizador.",
  PS: "OBS:",

  ANALYSIS_INIT_ERROR: "Se produjo un error al iniciar el análisis; por favor intente iniciarlo nuevamente.",
  LOADING_HOMEPAGE_2: "Este proceso puede tardar algunos minutos.",
  CANCEL: "Cancelar",

  NO_ACTIVE_NETWORK: "El TS Scope PA no encontró una red activa; asegúrese de que esté conectado correctamente a una red PROFIBUS PA. Después de realizar la conexión, por favor reinicie el TS Scope PA.",
  INVALID_SERIAL: "El número de serie no corresponde a este TS Scope PA. Por favor reinstale el programa con un número de serie válido.",

  CLEANING_BUFFER: "Limpiando buffer...",
  SEPARATING_WAVES: "Analizando datos...",
  VERIFYING_NETWORK_TYPE: "Verificando red...",
  FINDING_SLAVES: "Encontrando esclavos...",

  TIME_ON: "Tiempo encendido:",

  SIGNAL_QUALITY: "Calidad del señal",
  SIGNAL_QUALITY_DESCRIPTION_1: "En la columna “Señal” siempre se considera el peor caso, para amplitud media y mínima.",

  GOOD: "Bueno",
  GOOD_DESCRIPTION_1: "• Amplitud mínima entre 550 y 1100 mV",
  GOOD_DESCRIPTION_2: ". Esclavos comunicándose normalmente; la norma indica entre 750 mV",
  GOOD_DESCRIPTION_3: " y 1 V",

  ATTENTION: "Atención - Acción preventiva",
  ATTENTION_DESCRIPTION_1: "• Amplitud mínima entre 350 y 550 mV",
  ATTENTION_DESCRIPTION_2: "• Amplitud mínima entre 1100 y 1400 mV",

  BAD: "Malo - Acción correctiva",

  BAD_DESCRIPTION_1: "• Amplitud mínima menor que 350 mV",
  BAD_DESCRIPTION_2: ". Puede ser causada por exceso de terminadores, bus demasiado largo, humedad, etc.",
  BAD_DESCRIPTION_3: "• Amplitud mínima mayor que 1400 mV",
  BAD_DESCRIPTION_4: ". Puede ser causada por falta de terminadores, problemas en equipos, etc.",

  LIGHT_TONES: "Tonos claros",
  LIGHT_TONES_DESCRIPTION: "• El TS Scope PA no está encontrando respuesta del esclavo; por lo tanto, el software mantiene las mediciones de la última captura y deja el tono claro indicando que no está actualizando los datos.",

  NOISE_DESCRIPTION_1: "O ",
  NOISE_DESCRIPTION_2: "Ruido",
  NOISE_DESCRIPTION_3: " se calcula durante el tiempo de ",
  NOISE_DESCRIPTION_4: "idle",
  NOISE_DESCRIPTION_5: " de cada uno de los dispositivos en la red y no debe superar ",
  NOISE_DESCRIPTION_6: "Estos valores son de orden práctico.",

  JITTER_DESCRIPTION_1: "O ",
  JITTER_DESCRIPTION_2: "Jitter",
  JITTER_DESCRIPTION_3: " es el desplazamiento de la señal en el tiempo con respecto al cero ideal.",
  JITTER_DESCRIPTION_4: "Si ocurre, puede hacer que la electrónica del equipo PROFIBUS PA no pueda leer el mensaje.",
  JITTER_DESCRIPTION_5: "Su valor definido por norma debe ser menor que ",
  JITTER_DESCRIPTION_6: ", que equivale a ",

  UNBALANCE_DESCRIPTION_1: "O ",
  UNBALANCE_DESCRIPTION_2: "desbalanceo",
  UNBALANCE_DESCRIPTION_3: " es la medida del desplazamiento de la señal con respecto al cero AC, es decir, si la señal está desplazada hacia arriba o hacia pestañajo. ",
  UNBALANCE_DESCRIPTION_4: "Esta medición se realiza mediante la diferencia de la media de la parte negativa y positiva de la señal. ",
  UNBALANCE_DESCRIPTION_5: "Indica, generalmente, un problema en la electrónica de los equipos, siendo el principal una posible falla en el aislamiento de la alimentación/señal PROFIBUS PA.",

  // ---------------------------- Osciloscopio ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A e B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitud A",
  AMPLITUDE_B: "Amplitud B",
  ADDRESS_DP: "Dirección: ",
  CHANNEL_DP: "Canal: ",
  WAVE_A: "Señal A",
  WAVE_B: "Señal B",
  WAVE_PA: "Señal PA",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tiempo (ns)",
  TIME_US: "Tiempo (μs)",
  TIME_MS: "Tiempo (ms)",
  TIME_S: "Tiempo (s)",

  AMPLITUDE_PLACEHOLDER: "0,0 mV",
  TIME_INTERVAL_PLACEHOLDER: "0,0 ",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Después de presionar PLAY, la forma de onda se actualiza cada 2 segundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar los controles es necesario seleccionar la visualización manual y elegir un dispositivo.",

  VISUALIZATION: "Visualización",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  KBPS: "Kbps",

  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  TIME: "Tiempo: ",

  MASTER_SUFFIX: " - Maestro",
  MASTER_PREFIX: "Maestro - ",

  STD_WAVE_FORM: "Forma de onda estándar",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de exceso de terminador",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de pocos terminadores",
  FOR_MORE_INFO: "Para información adicional, consulte a Toledo & Souza o las directrices de PROFIBUS International. Cabe destacar que los eventos demostrados pueden ocurrir en conjunto, lo que cambia los patrones mostrados.",

  // ---------------------------- Gráfico de barras ----------------------------
  ORDER_BY: "Ordenar por",
  AMPLITUDE_ASC: "Amplitud creciente",
  AMPLITUDE_DESC: "Amplitud decreciente",
  ADDRESS_ASC: "Dirección creciente",
  VOLTAGE_V: "Tensión (V)",
  VOLTAGE_MV: "Tensión (mV)",
  UNBALANCE_PORCENT: "Tasa de desbalanceo (%)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensión (V)",
  ORDER: "Ordenación",
  REFRESH_DATA: "Actualizar datos",
  LOADING: "Cargando",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Seleccione un tipo de gráfico de barras",
  ACTUAL: "Actual",
  VARIATION: "Variación",
  CURRENT: "Actual",
  MICROSSECOND_TITLE: "Microsegundos (µs)",

  NOISE_PA: "Ruido: ",
  NOISE_MIN: "Ruido mínimo",
  NOISE_MAX: "Ruido máximo",
  NOISE_ASC: "Ruido creciente",
  NOISE_DESC: "Ruido decreciente",

  JITTER_PA: "Jitter: ",
  JITTER_MIN: "Jitter Mínimo",
  JITTER_MAX: "Jitter Máximo",
  JITTER_ASC: "Jitter creciente",
  JITTER_DESC: "Jitter decreciente",

  UNBALANCE_PA: "Desbalanceo: ",
  UNBALANCE_ASC: "Desbalanceo creciente",
  UNBALANCE_DESC: "Desbalanceo decreciente",

  MINIMUM_MASC: "Mínimo",
  MINIMUM_FEM: "Mínima",
  MAXIMUM_MASC: "Máximo",
  MAXIMUM_FEM: "Máxima",

  COMPLETE: "Completo",
  DETAILED: "Detallado",

  MODE_POPUP_TEXT_1: "El modo detallado muestra la parte inicial de la forma de onda completa que fue capturada (como si se hiciera zoom en la parte inicial de la onda).",
  MODE_POPUP_TEXT_2: "El modo completo muestra la forma de onda en su totalidad.",

  JITTER_MESSAGE_HEADER: "Interpretación del valor de jitter",
  JITTER_MESSAGE_1: "El valor de jitter corresponde al valor absoluto registrado por TS Scope PA. El valor absoluto representa únicamente la magnitud de un número, independientemente de su signo (positivo o negativo). En otras palabras, indica la distancia del número respecto a cero.",
  JITTER_MESSAGE_2: "Si el valor mínimo de jitter registrado es -4 µs, el valor mostrado será 4 µs.",
  EXAMPLE: "Ejemplo",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Por favor, escriba un tipo de evento válido.",
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o tipo de evento",
  LOG_WAITING: "Cargando datos del log",
  HORARY: "Hora",
  DESCRIPTION: "Descripción",
  TYPE: "Tipo",

  PA_TERMINATION_OFF_LOG_DESCRIPTION: "El TS Expert detectó una condición de falta de terminación.",
  PA_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "El TS Expert detectó una condición de Jitter fuera de especificación.",
  PA_NOISE_LOG_DESCRIPTION: "El TS Expert detectó una posible condición de ruido en la red PA.",
  PA_INVERTED_POLARITY_LOG_DESCRIPTION: "El TS Expert detectó una posible condición de inversión de polaridades.",
  PA_HIGH_RESISTANCE_LOG_DESCRIPTION: "El TS Scope PA detectó una condición de señal atenuada.",
  PA_DADOS_LOG_DESCRIPTION: "El TS Scope PA detectó una anomalía en el estado de la variable ",
  PA_UNBALANCE_LOG_DESCRIPTION: "El TS Scope PA detectó una condición de desbalanceo.",
  EVENT_CHECKED_SUCCESS: "El evento fue limpiado correctamente.",

  // ---------------------------- Informe ----------------------------
  REPORT_EXPORT_NAME: "Informe TS Scope PA",

  HEADER_TEXT: "TS Scope PA",
  GENERATE_REPORT: "Generar informe",

  SELECT_CLIENT: "Clientes guardados",
  SELECT_EXECUTOR: "Empresas ejecutoras guardadas",
  CLIENT_NOT_FOUND: "Sin clientes guardados con ese nombre",
  EXECUTOR_NOT_FOUND: "Sin empresas guardadas con ese nombre",

  GENERAL_REPORT: "Informe general – TS Scope PA",
  DATA_REPORT: "Informe de datos – TS Scope PA",

  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora",
  CONFORMITY: "Conformidad",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  DROPDOWN_PLACEHOLDER: "Elija una opción",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme con restricciones",
  NON_CONFORM: "No conforme",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Ubicación:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- Email:",

  ETHERNET_INFO: "Información ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nombre de la red: ",

  SUMMARY: "Sumario",
  CHANNEL: "Canal",
  VALOR_DADOS: "Valor",
  VARIEAVEL_DADOS: "Variable",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Osciloscopio",
  BAR_GRAPH_PAGE_TITLE: "3 - Gráfico de barras",
  DADOS_PAGE_REPORT_TITLE: "4 - Datos",
  LOG_PAGE_TITLE: "5. - Log de eventos",

  LAST_200_EVENTS: "Últimos 200 eventos",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "PROFIBUS PA",

  ANALYZER_VERSION_STRING: "- Versión del TS Scope PA:",
  ANALYSIS_INIT: "- Hora de inicio del análisis:",

  ANALYSIS_INFO: "Información del análisis",
  GENERATED_BY: "- Generado por TS Scope PA",
  HARDWARE_VERSION: "- Versión de hardware:",
  SOFTWARE_VERSION: "- Versión de software:",
  DATE_TIME: "- Fecha y hora:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Maestro:",
  NUM_SLAVES: "- Esclavos:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "......................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DADOS_DOTS: ".........................................................................................................................................",
  DISCLAIMER_DOTS: ".................................................................................................................................",

  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",
  GENERATING_REPORT_SUCCESS: "Informe generado correctamente. Para guardarlo, haga clic en guardar informe pestañajo.",

  MASTER_PA: "Maestro: ",
  SLAVE_PA: "Esclavo: ",
  SIGNAL_PA: "Señal: ",
  AMPLITUDE_PA: "Amplitud: ",
  AMPLITUDE_MIN_PA: "Amplitud mínima: ",
  AMPLITUDE_MAX_FF: "Amplitud máxima: ",
  DEVIATION_DP: "Desviación: ",
  I_FAULTS_DP: "Fallos: ",
  PERCENT_FAULTS_DP: "% de fallos: ",

  OVERSHOOTING_DP: "Sobresseñal: ",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista en PA, de modo que cualquier indicación de corrección debe ser realizada por el usuario. Por esta razón, se recomienda el acompañamiento de un ingeniero especialista o técnico responsable del análisis para validar la información proporcionada por el producto. Por lo tanto, Toledo & Souza se exime de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, y no ofrece ninguna garantía con relación a la integridad, calidad o adecuación de la información proporcionada, ya que depende del análisis técnico de un profesional capacitado; en ausencia de este, el usuario asumirá el riesgo de que el contenido pueda ser impreciso, incompleto o no atender sus necesidades y requisitos.",

  // ---------------------------- Gestión de información ----------------------------
  SAVE: "Guardar",
  REMOVE: "Eliminar",

  CHOOSE_CLIENT_ID: "Es necesario elegir un identificador para el cliente.",
  CLIENT_ID_ALREADY_EXISTS: "Ya existe un cliente guardado con ese identificador.",
  SAVE_CLIENT_SUCCESS: "¡Cliente guardado correctamente!",
  SAVE_CLIENT_ERROR: "Se produjo un error al guardar la información del cliente.",

  CHOOSE_EXECUTING_COMPANY_ID: "Es necesario elegir un identificador para la empresa ejecutora.",
  EXECUTING_ID_ALREADY_EXISTS: "Ya existe una empresa ejecutora guardada con ese identificador.",
  SAVE_EXECUTING_COMPANY_SUCCESS: "¡Empresa ejecutora guardada correctamente!",
  SAVE_EXECUTING_COMPANY_ERROR: "Se produjo un error al guardar la información de la empresa ejecutora.",

  CHOOSE_CLIENT_FIRST: "Es necesario elegir primero un cliente.",
  CHOOSE_EXECUTING_COMPANY_FIRST: "Es necesario elegir primero una empresa ejecutora.",

  ALTER_CLIENT_SUCCESS: "Información del cliente modificada correctamente.",
  ALTER_CLIENT_ERROR: "Se produjo un error al modificar la información del cliente.",

  ALTER_EXECUTING_COMPANY_SUCCESS: "Información de la empresa ejecutora modificada correctamente.",
  ALTER_EXECUTING_COMPANY_ERROR: "Se produjo un error al modificar la información de la empresa ejecutora.",

  REMOVE_CLIENT: "Eliminar cliente",
  REMOVE_EXECUTING_COMPANY: "Eliminar empresa ejecutora",

  REMOVE_CLIENT_SUCCESS: "Información del cliente eliminada correctamente.",
  REMOVE_CLIENT_ERROR: "Se produjo un error al eliminar la información del cliente. Verifique si aún está guardado.",

  REMOVE_EXECUTING_COMPANY_SUCCESS: "Información de la empresa ejecutora eliminada correctamente.",
  REMOVE_EXECUTING_COMPANY_ERROR: "Se produjo un error al eliminar la información de la empresa ejecutora. Verifique si aún está guardada.",

  CONFIRM_REMOVE_CLIENT_TEXT: "¿Está seguro de que desea eliminar este cliente?",
  CONFIRM_REMOVE_EXECUTING_COPANY_TEXT: "¿Está seguro de que desea eliminar esta empresa ejecutora?",

  YES: "Sí",
  NO: "No",

  // ---------------------------- Relacionado con la página de configuración ----------------------------
  USERNAME: "Usuario",
  NEW_PWD: "Nueva contraseña",
  REPEAT_PWD: "Repetir contraseña",
  TAG_PA: "Tag del TS Scope PA",
  TAG_CHANNELS: "Red de prueba",

  TS_SCOPE_PA_REPORT_CHANNEL: "Informe TS Scope PA - Canal",
  REPORTS_TS_SCOPE_PA: "Informes - TS Scope PA.zip",

  PROJECT_NAME_: "Nombre del proyecto",
  NETWORK_NAME_: "Nombre de la red",
  LOCATION_: "Ubicación",
  COMPANY_NAME_: "Nombre de la empresa",
  RESPONSIBLE_NAME: "Nombre del responsable",
  ADDRESS_: "Dirección",
  CITY: "Ciudad",
  TEL: "Teléfono",
  CLIENT_LOGO: "Logo del cliente",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Logo de la empresa ejecutora",
  CHANNELS_INCLUDED_REPORT: "Canales incluidos en el informe",

  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Reiniciar sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Actualización de software",
  INTERFACE_CONFIG: "Configuraciones de interfaz",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",
  ALTER_LOGIN: "Cambiar login",
  ARE_YOU_SURE_ALTER_CONFIG: "¿Está seguro de que desea cambiar las configuraciones del TS Scope PA?",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está dañado.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Se produjo un error al iniciar sesión: nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Se produjo un error al iniciar sesión:",

  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "El archivo fue enviado correctamente.",
  SEND_FILE_SUCCESS_WARNING: "No olvide verificar si la tarjeta de red de su computadora está en la misma subred que la IP: ",
  SEND_FILE_FAILURE: "Se produjo un error al enviar el archivo.",
  SEND_FILES_SUCCESS: "Los archivos fueron enviados correctamente.",
  SEND_FILES_FAILURE: "Se produjo un error al enviar los archivos.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILE_WRONG_FILENAME: "Nombre no válido. El archivo de actualización debe llamarse: updateSPA.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se dañó durante el envío.",
  SEND_CONFIG_SUCCESS: "Las configuraciones fueron enviadas correctamente.",
  SEND_CONFIG_FAILURE: "Se produjo un error al enviar las configuraciones.",
  SEND_CONFIG_WAITING: "Enviando las configuraciones.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de las configuraciones.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  START_MESSAGE_SUCCESS: "El TS Scope PA se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Se produjo un error al iniciar el TS Scope PA.",
  STOP_MESSAGE_SUCCESS: "El TS Scope PA se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Se produjo un error al detener el TS Scope PA.",
  WAITING: "Espere un momento",
  CLEAN_LOG_SUCCESS_1: "El log del 'Canal ",
  CLEAN_LOG_SUCCESS_2: "' fue limpiado correctamente.",
  CLEAN_LOG_FAILURE: "Se produjo un error al limpiar el log.",
  CLEAR: "Limpiar",
  CLEAN_STATISTICS_SUCCESS: "Las estadísticas fueron limpiadas correctamente.",
  CLEAN_STATISTICS_FAILURE: "Se produjo un error al limpiar las estadísticas.",
  RESET_TRAFFIC_SUCCESS: "Los valores se pondrán a cero en el próximo escaneo.",
  RESET_TRAFFIC_FAILURE: "Se produjo un error al poner a cero los incrementos de error.",
  RESET_DEVICES_SUCCESS: "Los datos de los dispositivos fueron limpiados correctamente.",
  RESET_DEVICES_FAILURE: "Se produjo un error al limpiar los datos de dispositivos.",
  CHANGE_USERNAME_SUCCESS: "El nombre de usuario fue modificado correctamente. Por favor inicie sesión nuevamente.",
  CHANGE_USERNAME_FAILURE: "Se produjo un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña fue modificada correctamente. Por favor inicie sesión nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Se produjo un error al cambiar la contraseña: ",
  RESET_RETRIES_SUCCESS: "Los reintentos fueron limpiados correctamente.",
  RESET_RETRIES_FAILURE: "Se produjo un error al limpiar los reintentos.",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La máscara ingresada no es válida",
  INVALID_GATEWAY: "\n- El gateway ingresado no es válido",
  INVALID_DNS: "\n- El DNS ingresado no es válido",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del TS Scope PA",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del servidor NTP",
  TAG_TOO_LONG: "El tamaño de la tag no puede superar los 30 caracteres",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar una zona horaria para configurar el servidor NTP",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz office no puede estar en la misma subred que la interfaz ETHERNET.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz ETHERNET no puede estar en la misma subred que la interfaz office.",
  SUBNET_OVERLAP_WLAN: "\n- El TS Scope PA detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred de la WLAN. Por este motivo no es posible configurar la WLAN con la dirección IP y máscara elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- El TS Scope PA detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred de la WLAN. Por este motivo no es posible configurar la interfaz ETHERNET con la dirección IP y máscara elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como IP del TS Scope PA",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como máscara de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del TS Scope PA",
  NETWORK_IP_MSG: "\n- La IP de red no puede utilizarse como IP del TS Scope PA",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del gateway",
  NETWORK_GATEWAY_MSG: "\n- La IP de red no puede utilizarse como IP del gateway",

  CHOOSE_A_CHANNEL: "Para guardar la tag es necesario seleccionar un canal",

  ALTER_USERNAME: "CAMBIAR USUARIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Se produjo un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada correctamente. Espere unos 3 minutos para que el sistema se reinicie completamente.",

  SELECT_FILE: "Por favor seleccione un archivo para enviar",
  SELECT_GSD_FLIE: "Por favor seleccione al menos un archivo GSD para enviar",
  SENDING_GSD_FILES: "Enviando archivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para acompañar la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el TS Scope PA. Por favor espere.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados, preparando para reiniciar el TS Scope PA.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el TS Scope PA, espere algunos minutos.",
  UPDATE_SUCCESS: "¡La actualización se realizó correctamente!",
  UPDATE_ERROR_STRING: "Se produjo el siguiente error al actualizar el TS Scope PA: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar las configuraciones de interfaz.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡Las configuraciones de interfaz fueron actualizadas correctamente!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Se produjo un error al enviar los siguientes archivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Se produjo un error al eliminar los siguientes archivos GSD: ",

  ALTER: "Cambiar",
  CHANNELS: "Canales",
  CHANNELS_TAGS: "Tags de los canales",
  DEVICES_TAGS: "Tags de los dispositivos",

  TAG_AND_NOTE_FROM_CHANNEL: "La tag del canal ",
  WAS_SUCCESSFULLY_ALTERED: " fue modificada correctamente!",
  ALTER_TAG_ERROR: "Se produjo un error al cambiar la tag del canal ",
  ALTER_TAG_ERROR_REASON: ".\nMotivo: ",
  ERROR_REASON: ".\nMotivo: ",

  NOTE: "Observación",
  MONITOR_IP: "IP del TS Scope PA",

  IS_IN_SEGMENT_QUESTION: "¿Pertenece al segmento?",

  IN_SEGMENT_DEVICES: "Dispositivos del segmento",
  UPDATING_DATA: "Actualizando información, espere",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertenecientes al mismo segmento que este canal del TS Scope PA.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Si el dispositivo está desmarcado en esta lista, significa que no pertenece al mismo segmento que este canal del TS Scope PA.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Si no pertenece al mismo segmento, la forma de onda vista en el osciloscopio puede no corresponder a la forma de onda real del dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "¿Está seguro de que desea realizar los cambios en la lista de dispositivos pertenecientes al segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Se produjo un error al cambiar la lista de dispositivos del segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "¡La lista de dispositivos del segmento fue modificada correctamente!",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisión y acceso Web a los datos del TS Scope PA.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando hay adaptador disponible.",
  WLAN_POPUP_2: "Utilizado para supervisión y acceso Web a los datos del TS Scope PA.",

  SEND_NTP_CONFIG_WAITING: "Enviando las configuraciones del servidor NTP.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_OFF: "Apagar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea encender el servidor NTP? Para ello el TS Scope PA deberá reiniciarse.",
  TURN_NTP_SERVER_OFF_QUESTION: "¿Está seguro de que desea apagar el servidor NTP? Para ello el TS Scope PA deberá reiniciarse.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de la información del servidor NTP.",
  PROCESSING_NTP_INFO: "Procesando la información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Se produjo un error al enviar la información al servidor NTP. Verifique si la dirección IP del servidor es correcta. Si lo es, verifique también si el servicio NTP está encendido e intente nuevamente.",

  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP fue encendido correctamente.",
  NTP_INFO_TURNED_ON_FAILURE: "Se produjo un error al encender el servidor NTP.",
  NTP_INFO_FAILURE: "Fallo al sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",
  TURN_ON_DATE: "\nLa hora del servidor fue actualizada a: ",

  MONITOR_WILL_BE_RESTARTED: "\nEl TS Scope PA será reiniciado ahora,",
  MONITOR_RESTART_SUCCESS: "El TS Scope PA fue reiniciado correctamente.",
  MONITOR_RESTART_FAILURE: "Se produjo un error al reiniciar el TS Scope PA.",

  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP fue apagado correctamente.",
  NTP_INFO_TURNED_OFF_FAILURE: "Se produjo un error al apagar el servidor NTP.",
  TURN_OFF_DATE: "\nHora de apagado: ",

  TAG_CONFIG: "Tag del segmento",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag del TS Scope PA fue modificada correctamente.",
  TAG_CHANGE_FAILURE: "Se produjo un error al modificar la tag del TS Scope PA.",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / deshabilitar las no conformidades que serán informadas por la herramienta.",
  DNS: "DNS",

  REASON_PA: "Motivo: ",
  // ---------------------------- Relacionado con la página de edición de tags ----------------------------
  ADD_ALTER_TAGS: "Agregar/Cambiar Tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nueva TAG",
  REMOVE_ALL_TAGS: "Eliminar todas las Tags",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "La tag fue modificada correctamente.",
  CHANGE_TAG_FAILURE: "Se produjo un error al cambiar la tag",
  REMOVE_TAG_SUCCESS: "Las tags fueron eliminadas correctamente.",
  REMOVE_TAG_FAILURE: "Se produjo un error al eliminar las tags",
  IMPORT_TAGS_SUCCESS: "Las tags fueron importadas correctamente",
  IMPORT_TAGS_SUCCESS_1: "Las tags del canal ",
  IMPORT_TAGS_SUCCESS_2: " fueron importadas correctamente",

  IMPORT_TAGS_FAILURE: "Se produjo un error al importar las tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  CHOOSE_A_CHANNEL_FIRST: "Es necesario seleccionar primero un canal",
  CHOOSE_A_DEVICE_FIRST: "Es necesario seleccionar primero un dispositivo",

  THE_IP_DP: "O IP: ",
  TOOK_TOO_LONG_TO_RESPOND: " tardó demasiado en responder.",

  TAGS_CONFIG: "CONFIGURACIÓN DE TAGS",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Fuerza de la señal",
  FREQUENCY: "Frecuencia",
  QUALITY: "Calidad",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidad",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendiendo el adaptador WLAN, por favor espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Máscara",
  PASSWORD: "Contraseña",

  ALTER_SCOPE_WLAN_CONFIG: "¿Está seguro de que desea cambiar las configuraciones WLAN del TS Scope PA?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN del TS Scope PA.",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar las configuraciones WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el TS Scope PA está conectado o no a la red WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar las configuraciones mientras el adaptador WLAN esté apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda encarecidamente que las configuraciones WLAN se cambien solo al acceder al TS Scope PA mediante la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / máscara, si los campos aparecen en blanco después de la actualización, esto es un fuerte indicio de que:",
  WLAN_CONFIG_POPUP_4: "Ya existe otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La máscara de red es demasiado restrictiva y no admite la IP ingresada.",

  WLAN_ADAPTER_NOT_FOUND_1: "El TS Scope PA no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique si el adaptador está desconectado o con mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado ni con mal contacto, intente sustituirlo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores soluciona el problema, póngase en contacto con Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar las configuraciones WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡Las configuraciones WLAN fueron actualizadas correctamente!",
  SEND_WLAN_CONFIG_WAITING: "Enviando las configuraciones, por favor espere. Esto puede tardar aproximadamente un minuto.",
  LOADING_WAITING: "Cargando información, por favor espere.",
  WLAN_INFO: "Información WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "No fue posible conectarse a la red WLAN. Si el problema persiste, intente reiniciar el TS Scope PA o el router WLAN.",

  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  INVALID_HOSTNAME_1: "El hostname debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El hostname debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  HOSTNAME_CONFIG_SUCCESS: "El hostname fue configurado correctamente.",
  HOSTNAME_CONFIG_ERROR: "Se produjo un error al configurar el hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID oculto",
  OPTIONAL: " (Opcional)",

  FIXED_IP: "IP Fijo",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar las configuraciones WLAN del TS Scope PA?",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando las configuraciones del TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "Las configuraciones del TS Expert fueron guardadas correctamente.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Se produjo un error al guardar las configuraciones del TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configuraciones del TS Expert",

  PA_TERMINATOR_OFF_LIST_HEADER: "Falta de terminador",
  PA_TERMINATOR_OFF_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de falta de terminación en la red.",

  PA_CAPACITIVE_EFFECT_LIST_HEADER: "Jitter fuera de especificación",
  PA_CAPACITIVE_EFFECT_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de jitter fuera de especificación.",

  PA_HIGH_RESISTANCE_LIST_HEADER: "Señal atenuada",
  PA_HIGH_RESISTANCE_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de señal atenuada en el bus PA.",

  PA_INVERTED_POLARITY_LIST_HEADER: "Polaridad invertida",
  PA_INVERTED_POLARITY_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de polaridad invertida.",

  PA_NOISE_LIST_HEADER: "Ruido",
  PA_NOISE_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de ruido en la red PA.",

  PA_DADOS_LIST_HEADER: "Estado de la variable",
  PA_DADOS_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de anomalía en el estado de la variable.",

  PA_UNBALANCE_LIST_HEADER: "Desbalanceo",
  PA_UNBALANCE_LIST_CONTENT: "Cuando esta opción esté activada, el TS Expert indicará al usuario una posible condición de desbalanceo.",

  PA_GENERAL_SIGNAL_LOSS_HEADER: "Pérdida general de señal PA",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Tag del Scope:",
  CHANNEL_TAG_2: "Tag del canal:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - TS Scope PA",

  TS_EXPERT_POPUP_1: "En esta pestaña se presenta la información del TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por el TS Scope PA en reds PA.",
  TS_EXPERT_POPUP_3: "De forma automatizada, mantenimiento, ingeniería y equipos relacionados pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso del TS Expert no excluye la necesidad del análisis humano ni sustituye esas capacidades de crear correlaciones de datos e interpretación.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifique su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de lista de acciones, por favor espere.",
  ACTIONS_LIST_NAME: "Lista de acciones - TS Scope PA - Canal",
  GENERATING_ACTIONS_LIST_WAITING_2: "Finalizando...",
  SAVE_ACTIONS_LIST: "Guardar lista de acciones",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado correctamente. Para guardarlo, haga clic en guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "El TS Expert no detectó ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No existen eventos para analizar.",

  NO_EVENT_SELECTED: "No hay eventos seleccionados",
  CHOOSE_AN_EVENT: "Elija un evento para ver las acciones sugeridas.",

  DETAILING: "Detalles",

  CHECKED: "Limpiar",
  BATCH_CHECK: "Limpiar todos",

  PROBLEM_CHECKED: "El evento fue limpiado correctamente",
  PROBLEM_CHECK_ERROR: "Se produjo un error al limpiar el evento.",

  QUANTITY_DP: "Cantidad: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "El puerto aún está inactivo",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como limpio?",

  LAST_UPDATED: "Actualizado por la última vez en: ",
  THIS_COMPUTER_TIME: " (Tiempo de esta computadora)",

  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  UNKNOWN: "Desconocido",

  ALL_EVENTS_WERE_CHECKED: "Todos los eventos fueron verificados correctamente.",
  CHECK_EVENT_OBS: "\nEs importante destacar que algunos datos tardan hasta 15 minutos en actualizarse; de esta forma, se sugiere esperar un tiempo para limpiar esta lista haciendo clic en verificar.\n",

  UNABLE_TO_CHECK_TERMINATION_OFF_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando una condición de falta de terminación:\n",
  UNABLE_TO_CHECK_CAPACITIVE_EFFECT_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando Jitter fuera de especificación:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope sigue detectando una condición de ruido (amplitud mayor que el 30% de la amplitud de la señal del esclavo):\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando una condición de inversión de polaridad:\n",
  UNABLE_TO_CHECK_HIGH_RESISTANCE_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando señal atenuada:\n",
  UNABLE_TO_CHECK_DADOS_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando una anomalía en el estado de la variable:\n",
  UNABLE_TO_CHECK_UNBALANCE_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope PA sigue detectando un desbalanceo:\n",

  PAGE: "Página",

  // ---------------------------- FF TERMINADOR OFF ----------------------------
  PA_TERMINATION_OFF_SUGGESTION_1: "Cuando haya falta de terminador se sugiere:",
  PA_TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente si los terminadores en ambos extremos del segmento están conectados, ya sea en el acoplador y la última junction box o en el acoplador y el esclavo más distante.",
  PA_TERMINATION_OFF_SUGGESTION_3: "Se recomienda esperar una parada o programar con producción antes de conectar/instalar el terminador.",

  // ---------------------------- EFEITO CAPACITIVO ----------------------------
  CAPACITIVE_EFFECT_SUGGESTION_1: "Cuando se detecte presencia de Jitter fuera de especificación se sugiere:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Verificar los siguientes ítems:",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Aislamiento de los equipos;",
  CAPACITIVE_EFFECT_SUGGESTION_4: "Humedad en el bus;",
  CAPACITIVE_EFFECT_SUGGESTION_5: "Problemas en la electrónica de los esclavos;",
  CAPACITIVE_EFFECT_SUGGESTION_6: "Oxidaciones en las conexiones de los esclavos;",
  CAPACITIVE_EFFECT_SUGGESTION_7: "Oxidaciones en las conexiones de las junction box / barreras;",
  CAPACITIVE_EFFECT_SUGGESTION_8: "Cable largo.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  PA_HIGH_RESISTANCE_SUGGESTION_1: "Cuando haya señal atenuada en el bus se sugiere:",
  PA_HIGH_RESISTANCE_SUGGESTION_2: "Verificar si algún equipo del segmento tiene el terminador interno conectado, como en el caso de las junction box. Si ningún equipo tiene terminador interno conectado, verificar la electrónica de los esclavos, aislándolos individualmente del bus.",
  PA_HIGH_RESISTANCE_SUGGESTION_3: "También se deben verificar puntos de alta resistencia como bornes flojos y cables aplastados.",

  // ---------------------------- INVERTED POLARITY ----------------------------
  PA_INVERTED_POLARITY_SUGGESTION_1: "Cuando se detecte presencia de polaridad invertida se sugiere:",
  PA_INVERTED_POLARITY_SUGGESTION_2: "No todos los acopladores aceptan la polaridad invertida, por lo tanto esto puede generar problemas en la red.",
  PA_INVERTED_POLARITY_SUGGESTION_3: "Se debe verificar la instalación; si está correcta, contactar al fabricante del esclavo.",

  // ---------------------------- NOISE ----------------------------
  PA_NOISE_SUGGESTION_1: "Cuando haya ruido o bajo aislamiento (fuga a tierra) se sugiere:",
  PA_NOISE_SUGGESTION_2: "Este es uno de los problemas más complejos de las reds industriales. A continuación tenemos 4 consejos básicos que deben ayudar a solucionar este problema:",
  PA_NOISE_SUGGESTION_3: "Verificar el aislamiento de las interfazs de los esclavos; una forma simple es desconectarlos uno a uno de la red y verificar si el problema persiste;",
  PA_NOISE_SUGGESTION_4: "Para atenuar el ruido es necesario verificar si todos los esclavos de la red están debidamente conectados a tierra;",
  PA_NOISE_SUGGESTION_5: "Es necesario verificar la equipotencialización del sistema de tierra; una forma simple es verificar si hay corriente de fuga en los cables PA. Se espera un valor inferior a 100 mA;",
  PA_NOISE_SUGGESTION_6: "Si hay una corriente mayor que 100 mA, una recomendación es aislar la malla en el esclavo, manteniendo siempre el esclavo conectado a tierra.",
  PA_NOISE_SUGGESTION_7: "Si el problema persiste después de estos consejos básicos, recomendamos buscar un especialista en reds PA.",

  // ---------------------------- DADOS ----------------------------
  PA_DADOS_SUGGESTION_1: "Estado de la variable indicando anomalía; se sugiere verificar:",
  PA_DADOS_SUGGESTION_2: "El estado de la variable y corregir;",
  PA_DADOS_SUGGESTION_3: "La condición de operación del instrumento.",
  PA_DADOS_SUGGESTION_4: "• Verificar el estado de la variable y corregir;",
  PA_DADOS_SUGGESTION_5: "• Verificar la condición de operación del instrumento.",

  // ------------------------ UNBALANCE ---------------------------
  PA_UNBALANCE_SUGGESTION_1: "Cuando haya desbalanceo se sugiere:",

  PA_UNBALANCE_SUGGESTION_2: "Verificar la influencia de los dispositivos en el bus, ya que defectos que causen alteración en las características eléctricas originales de los circuitos electrónicos y problemas de aislamiento electrónico pueden reflejarse en desbalanceo de la señal. Otra causa de este problema puede ser una fuga a tierra causada por un cable dañado.",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de acciones",

  MONITORING_INIT: "- Inicio del monitoreo: ",
  REPORT_GENERATION: "- Hora de generación del informe:",
  CHANNEL_TAG: "- Tag del canal: ",

  PA_TERMINATION_OFF_PAGE_TITLE: ". - Falta de terminador",
  PA_CAPACITIVE_EFFECT_PAGE_TITLE: ". - Jitter fuera de especificación",
  PA_HIGH_RESISTANCE_PAGE_TITLE: ". - Señal atenuada",
  PA_INVERTED_POLARITY_PAGE_TITLE: ". - Polaridad invertida",
  PA_NOISE_PAGE_TITLE: ". - Ruido o bajo aislamiento (fuga a tierra)",
  PA_DADOS_PAGE_TITLE: ". - Estado de la variable",
  PA_UNBALANCE_PAGE_TITLE: ". - Desbalanceo",

  SUGGESTION: "Se sugiere",
  EVIDENCE: "Evidencias",
  EVIDENCE_SINGULAR: "Evidencia",
  EVIDENCE_DESCRIPTION: "Captura de evidencia de la no conformidad informada por el TS Expert:",
  NO_EVIDENCE_DESCRIPTION_1: "En casos de ausencia de señal, la captura de evidencia de la no conformidad no se muestra, ya que no hay señal PA para analizar.",
  NO_EVIDENCE_DESCRIPTION_2: "Por esta razón, pestañajo se presenta una tabla que contiene todos los dispositivos cuyas señales no fueron detectadas, sus respectivos canales y la hora en que se detectó el problema.",

  PA_TERMINATION_OFF_PAGE_DESCRIPTION: "El TS Expert está indicando una posible falta de terminador en la red.",
  PA_CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "El TS Expert está indicando posible presencia de efecto capacitivo.",
  PA_HIGH_RESISTANCE_PAGE_DESCRIPTION: "El TS Expert está indicando posible exceso de terminadores o alta resistencia en el bus PA.",
  PA_INVERTED_POLARITY_PAGE_DESCRIPTION: "El TS Expert está indicando una posible condición de polaridad invertida.",
  PA_NOISE_PAGE_DESCRIPTION: "El TS Expert está indicando una posible condición de ruido en la red PROFIBUS PA.",
  PA_DADOS_PAGE_DESCRIPTION: "El TS Expert está indicando una posible condición de anomalía en el estado de la variable.",
  PA_UNBALANCE_PAGE_DESCRIPTION: "El TS Expert está indicando una posible condición de desbalanceo.",
  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canales activos",
  ACTIVE_CHANNELS_POPUP_1: "Permite configurar qué canales del TS Scope PA están activos en el momento (qué canales se utilizarán).",
  ACTIVE_CHANNELS_POPUP_2: "Se recomienda desactivar todos los canales que no se estén utilizando en el momento.",
  SAVING_ACTIVE_CHANNELS: "Guardandel canales activos, por favor espere.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "¡Los canales activos fueron guardados correctamente!\nDespués de presionar OK será redirigido a la página inicial del TS Scope PA.",
  SEND_ACTIVE_CHANNELS_ERROR: "Se produjo un error al guardar los canales activos",
  CANT_TURN_ALL_CHANNELS_OFF: "No es posible desactivar todos los canales del TS Scope PA al mismo tiempo.\n\nEs necesario que al menos uno de los canales permanezca activo.",

  // ---------------------------- PA NETWORK VERSION ----------------------------
  PA_NETWORK_VERSION: "Versión de la red PROFIBUS PA",
  PA_NETWORK_VERSION_2: "Versión 2.0",
  PA_NETWORK_VERSION_2_1: "Versión 2.1",
  PA_NETWORK_VERSION_POPUP_1: "Permite configurar la versión de la red PROFIBUS PA monitoreada por cada uno de los canales del TS Scope PA.",
  PA_NETWORK_VERSION_POPUP_2: "Las reds PA que utilizan el protocolo en la versión 2.0 soportan hasta 32 dispositivos por red, direccionados de 1 a 32.",
  PA_NETWORK_VERSION_POPUP_3: "Las reds PA que utilizan el protocolo en la versión 2.1 o superior soportan hasta 64 dispositivos, direccionados de 1A a 32A y de 1B a 32B.",
  DISABLED_CHANNELS_POPUP_1: "Algunos canales pueden aparecer como deshabilitados en esta pantalla, y la versión de la red PROFIBUS PA no podrá modificarse.",
  DISABLED_CHANNELS_POPUP_2: "Esto ocurre cuando están apagados; para modificar la versión de red del canal, vaya a la pantalla de configuraciones de los canales y habilítelos.",
  SEND_PA_TYPE_SUCCESS_1: "La versión de red del 'Canal ",
  SEND_PA_TYPE_SUCCESS_2: "' fue guardada correctamente!",
  SEND_PA_TYPE_ERROR: "Se produjo un error al guardar la versión de red del 'Canal ",

  PA_TERMINATION_OFF_DOTS: "....................................................................................................................",
  PA_CAPACITIVE_EFFECT_DOTS: "....................................................................................................",
  PA_HIGH_RESISTANCE_DOTS: "...........................................................................................................................",
  PA_INVERTED_POLARITY_DOTS: "......................................................................................................................",
  PA_NOISE_DOTS: "............................................................................................................................................",
  PA_DADOS_DOTS: "...................................................................................................................",
  PA_UNBALANCE_DOTS: "................................................................................................................................",

  PA_DISCLAIMER_EXPERT_DOTS: "....................................................................................................................................",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Inicializandel TS Scope PA, por favor espere."

});